import SecondLaneLogo from "./assets/SecondLaneLogo.svg";
import TopQR from "./assets/TopQR.svg";
import Group1 from "./assets/Group11.webp";
import Group2 from "./assets/Group12.webp";
import Group3 from "./assets/Group13.webp";
import Group4 from "./assets/Group14.webp";
import Group5 from "./assets/Group15.webp";
import Group6 from "./assets/Group6.svg";
import BottomQR from "./assets/BottomQR.svg";
import Group0 from "./assets/Group0.webp";

export const DesktopPWALandingScreen = (): JSX.Element => {
  const features = [
    {
      title: "Buy and Sell",
      description: "Browse live secondary listings and place bids on top private deals. Find the best prices to get liquidity on your assets",
      image: Group1,
      imagePosition: "right" as const,
    },
    {
      title: "Track your holdings", 
      description: "Upload your portfolio to trace value, structure, vesting, and performance over time",
      image: Group2,
      imagePosition: "left" as const,
    },
    {
      title: "Make informed decisions",
      description: "Explore funding round data, token unlocks, cap tables, and investor participation over 5k+ top projects",
      image: Group3, 
      imagePosition: "right" as const,
    },
    {
      title: "Get notified on assets of your choice",
      description: "Receive push notifications on real-time activity across your watched assets and portfolios.",
      image: Group4,
      imagePosition: "left" as const,
    },
    {
      title: "Everything in one place",
      description: "No more chats, screenshots, or spreadsheet chaos. One tool built for investors and founders.",
      image: Group5,
      imagePosition: "right" as const,
    },
  ];

  const stats = [
    { value: "$5B+", description: "in live secondary market dealflow" },
    { value: "10,000+", description: "strong network of active Web3 investors and founders" },
    { value: "100%", description: "compliant platform trusted by institutions" },
  ];

  return (
    <div className="w-full bg-white" style={{ fontFamily: "'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif" }}>

      {/* Hero Section */}
      <section className="min-h-screen flex relative">
        {/* EbonyRectangle - far right background */}
        {/* <div className="absolute top-0 right-0 h-full z-0">
          <img
            src={EbonyRectangle}
            alt="Ebony Rectangle Background"
            className="h-full w-auto object-cover"
          />
        </div> */}
        
        {/* Group0 SVG - under text */}
        <div className="absolute top-0 left-0 w-full h-full z-0">
          <img
            src={Group0}
            alt="Group0 Background"
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Content - over SVG */}
        <div className="flex-1 px-12 lg:px-[204px] py-20 lg:py-[100px] flex flex-col justify-center gap-12 relative z-30" style={{ transform: 'translateY(-10%)' }}>
          <img
            src={SecondLaneLogo}
            alt="SecondLane Logo"
            style={{ width: '320px', height: 'auto' }}
            className="lg:w-[320px]"
          />
          
          <div className="space-y-12">
            <h1 className="font-bold text-[#161616] text-2xl lg:text-4xl leading-tight" style={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
              WEB3 PRIVATE MARKETS <br />
              IN YOUR PHONE
            </h1>
            
            <div className="max-w-[50%]">
              <p className="text-black text-lg lg:text-2xl" style={{ lineHeight: '1.1', fontFamily: "'SFTSchriftedSansTRIAL-Light', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif" }}>
                Your all-in-one secondary market tool: access top buy and sell Web3 deals, 
                track your holdings, and monitor project data, all in one secure app.
              </p>
            </div>
            
            <div className="mt-8 flex items-center gap-12">
              <a 
                href="https://pwa.secondlane.io"
                target="_blank" 
                rel="noopener noreferrer"
                className="cursor-pointer transition-transform hover:scale-105 inline-block"
              >
                <img
                  src={TopQR}
                  alt="Download QR Code"
                  className="w-30 lg:w-40 h-30 lg:h-40"
                />
              </a>
              <p className="text-sm" style={{ fontFamily: "'SFT Schrifted Sans TRIAL', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
              fontWeight: 400,
              fontSize: '16px',
              lineHeight: '120%',
              letterSpacing: '0%' }}>
                Tap or scan to download<br />
                SecondLane App
              </p>
            </div>
          </div>
          
        </div>


      </section>

      {/* Features Section */}
      <section className="bg-white px-6 lg:px-[204px] py-0 lg:py-[50px]">
        {/* Section Header */}
        <div className="mb-20 lg:mb-[160px] relative">
          <div className="absolute w-32 lg:w-[150px] h-32 lg:h-[150px] -left-16 lg:-left-[75px] top-0 bg-[#e3fd5a]" />
          <h2 className="font-bold text-[#161616] text-4xl lg:text-[64px] leading-tight relative z-10" style={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
            Spot hot opportunities. <br />
            Find the best prices for your portfolio.
          </h2>
          <p className="font-light text-black text-lg lg:text-2xl mt-6 lg:mt-10 leading-relaxed" style={{ fontWeight: 400, lineHeight: '1.1' }}>
            Your all-in-one secondary market tool: access top buy and sell Web3 deals, 
            track your holdings, and monitor project data, all in one secure app.
          </p>
        </div>

        {/* Features List */}
        <div className="space-y-10 lg:space-y-[100px]">
          {features.map((feature, index) => (
            <div key={index} className="flex flex-col lg:flex-row items-center gap-8 lg:gap-10">
              {feature.imagePosition === "left" && (
                <div className="flex-1 order-1 lg:order-none">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-auto max-h-[400px] lg:max-h-[785px] object-contain"
                  />
                </div>
              )}
              
              <div className="flex-1 space-y-3 lg:space-y-6 order-2 lg:order-none">
                <h3 className="font-bold text-[#56584f] text-xl lg:text-4xl leading-tight" style={{ fontWeight: 600, letterSpacing: '-0.01em' }}>
                  {feature.title}
                </h3>
                <p className="font-light text-black text-lg lg:text-4xl leading-relaxed" style={{ fontWeight: 400, lineHeight: '1.1' }}>
                  {feature.description}
                </p>
              </div>

              {feature.imagePosition === "right" && (
                <div className="flex-1 order-1 lg:order-none">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-auto max-h-[400px] lg:max-h-[663px] object-contain"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Video Section */}
      <section className="bg-white px-6 lg:px-[100px] py-10 lg:py-[50px]">
        <div className="space-y-12 lg:space-y-10">
          <h2 className="text-[#56584f] text-center" style={{ 
            fontFamily: "'SFT Schrifted Sans TRIAL', 'SFT Schrifted Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
            fontWeight: 700,
            fontSize: '48px',
            lineHeight: '100%',
            letterSpacing: '0%'
          }}>
            See SecondLane App in action
          </h2>
          
          <div className="w-full max-w-4xl mx-auto">
            <video
              className="w-full h-auto rounded-lg shadow-lg"
              controls
              preload="metadata"
              poster=""
            >
              <source 
                src="https://d1yccqs7b7eo8o.cloudfront.net/e5c054bb-e845-4472-b631-c637ffd8d333" 
                type="video/mp4" 
              />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </section>


      {/* Group6 SVG under Features Section */}
      <div className="w-full">
        <img
          src={Group6}
          alt="Decorative Group6"
          className="w-full h-auto"
        />
      </div>
      {/* Stats Section */}
      <section className="bg-[#56584f] px-6 lg:px-[204px] py-0 lg:py-[50px]">
        <div className="space-y-12 lg:space-y-[60px]">
          <h2 className="font-bold text-white text-2xl lg:text-4xl" style={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
            Download the App to Tap Into:
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-[100px]">
            {stats.map((stat, index) => (
              <div key={index} className="space-y-2">
                <div className="font-bold text-[#e3fd5a] text-3xl lg:text-6xl" style={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
                  {stat.value}
                </div>
                <div className="font-bold text-white text-base lg:text-2xl leading-tight" style={{ fontWeight: 600, letterSpacing: '-0.01em' }}>
                  {stat.description}
                </div>
              </div>
            ))}
          </div>

          {/* Compliance Note */}
          <div className="space-y-4 lg:space-y-5 pt-8 lg:pt-12">
            <h3 className="font-normal text-white text-lg lg:text-2xl" style={{ fontWeight: 400, letterSpacing: '-0.01em' }}>
              Compliance Note
            </h3>
            <div className="space-y-2 text-white font-light text-sm lg:text-lg leading-tight" style={{ fontWeight: 400, lineHeight: '1.3' }}>
              <p>The SecondLane App displays non-binding indications of interest and project information for informational purposes only.</p>
              <p>SecondLane works with a registered U.S. broker-dealer to facilitate compliant transaction workflows.</p>
              <p>All bids and offers shown are non-binding indications of interest. Users are responsible for conducting their own due diligence and ensuring compliance with local regulations.</p>
            </div>
          </div>

          <div className="text-center w-full">
            <div className="text-[#e3fd5a] font-bold text-4xl lg:text-6xl tracking-tight w-full" style={{ fontWeight: 700, letterSpacing: '-0.02em', width: '100%', textAlign: 'center' }}>
              SecondLane
            </div>
          </div>
        </div>
      </section>

      {/* Decorative Sections */}
      <div className="bg-white">
        <div className="flex h-[90px]">
          <div className="w-[692px] bg-[#f8f8f8]" />
          <div className="flex-1 flex flex-col">
            <div className="flex-1 bg-[#56584f]" />
            <div className="flex-1 bg-[#e3fd5a]" />
          </div>
        </div>
      </div>

      {/* Download Section */}
      <section className="bg-[#e3fd5a] px-6 lg:px-[204px] py-0 lg:py-[50px]">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-[100px]">
          <h2 className="font-bold text-[#56584f] text-2xl lg:text-4xl text-center lg:text-left" style={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
            Download SecondLane App
          </h2>
          <a 
            href="https://pwa.secondlane.io" 
            target="_blank" 
            rel="noopener noreferrer"
            className="cursor-pointer transition-transform hover:scale-105"
          >
            <img
              src={BottomQR}
              alt="Download QR Code"
              className="w-[212px] lg:w-[297px] h-[212px] lg:h-[297px]"
            />
          </a>
        </div>
      </section>
    </div>
  );
};

export default DesktopPWALandingScreen;
